import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { NavigateWorkflowNode } from '@blaze-shared/workflow-domain';

import { VALUE_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Navigate')
export class NavigateNode extends BaseWorkflowNode<NavigateWorkflowNode> {
  static readonly VALUE_SOURCE_ID = VALUE_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.pageContextField, schemas),
      ...getColumnReferencesFromString(this.node.target, schemas),
      ...(this.node.urlParameters ?? []).flatMap((param, index) =>
        getColumnReferencesFromString(param.value, schemas, NavigateNode.VALUE_SOURCE_ID + index),
      ),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.pageContextField, schemas),
      ...getTagReferencesFromString(this.node.target, schemas),
      ...(this.node.urlParameters ?? []).flatMap((param, index) =>
        getTagReferencesFromString(param.value, schemas, NavigateNode.VALUE_SOURCE_ID + index),
      ),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(this.node.pageContextField, schemas, connectors),
      ...getParamReferencesFromString(this.node.target, schemas, connectors),
      ...(this.node.urlParameters ?? []).flatMap((param, index) =>
        getParamReferencesFromString(
          param.value,
          schemas,
          connectors,
          NavigateNode.VALUE_SOURCE_ID + index,
        ),
      ),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(this.node.pageContextField, schemas),
      ...getNamedInputReferencesFromString(this.node.target, schemas),
      ...(this.node.urlParameters ?? []).flatMap((param, index) =>
        getNamedInputReferencesFromString(
          param.value,
          schemas,
          NavigateNode.VALUE_SOURCE_ID + index,
        ),
      ),
    ];
  }
}
